module.exports = __webpack_public_path__ + "static/media/settings.7c4b20d0.svg";